<template>
  <Popup
    title="¡Revisa tu email!"
    subtitle="Te hemos enviado el resultado completo a tu correo electrónico, ¡así siempre lo tendrás a mano!"
    modifier-class="detail_success"
    color="moles--success"
    :showCloseIcon="true"
    :showHeaderIcon="true"
    @closePopup="$emit('close')"
  >
    <Success @closePopup="$emit('close')"></Success>
  </Popup>
</template>

<script>
import Popup from '@/funnels/components/layout/Popup';
import Success from '@/web/calculator/popup/Success';

export default {
  components: { Popup, Success },
};
</script>
